class Dropdown {
  constructor () {
    this.el = '.js-dropdown'
    this.activeEl = null

    this.initDefaults()
  }

  initDefaults () {
    this.initEvents()
  }

  initEvents () {
    $(document).on('click', this.el, e => this.toggle(e))
    $(document).on('click', e => this.onClickOut(e))
  }

  toggle (e) {
    const $target = $(e.currentTarget)
    if ($target.hasClass('open')) {
      $target.removeClass('open')
      this.activeEl = $target
      return
    }
    $(this.el).removeClass('open')
    $target.addClass('open')
    this.activeEl = null
  }

  onClickOut (e) {
    const $target = $(e.target)
    if ( !$(this.el).is(e.target) && $(this.el).has(e.target).length === 0 ) {
      $(this.el).removeClass('open')
      this.activeEl = null
    }
  }
}

document.addEventListener('DOMContentLoaded', e => {
  new Dropdown()
})